import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import i18n from "./i18n";
import store from "./redux/store"; 
import { I18nextProvider } from "react-i18next"; 
import { SnackbarProvider } from 'notistack';
import { installSessionInterceptor } from "./apis/sessionInterceptor";
import { installSubmitGuard } from "./apis/submitGuard";
import { StyleSheetManager } from "styled-components";

// UI-13d: styled-components v6 forwards every prop to the DOM; react-data-table-component's column options then
// land on <div>s as unknown attributes (~100 console errors per session). Keep them off DOM elements.
const TABLE_ONLY_PROPS = new Set(["allowOverflow", "button", "right", "center", "compact", "grow", "ignoreRowClick", "hide", "minWidth", "maxWidth"]);
const shouldForwardProp = (prop, target) => typeof target !== "string" || !TABLE_ONLY_PROPS.has(prop);

installSessionInterceptor(); // AUTH-35
installSubmitGuard(); // UI-07

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <StyleSheetManager shouldForwardProp={shouldForwardProp}>
  <Provider store={store}>
    <BrowserRouter>
      <I18nextProvider i18n={i18n}>
        <SnackbarProvider
          maxSnack={3}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          autoHideDuration={3000}
          preventDuplicate
        >  <App />
        </SnackbarProvider>
      </I18nextProvider>
    </BrowserRouter>
  </Provider>
  </StyleSheetManager>
);

reportWebVitals();
